import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import Toasted from 'vue-toasted'
import VueSweetalert2 from 'vue-sweetalert2';
import veeValidate from 'vee-validate'
import BlockUI from 'vue-blockui'
import '../static/assets/css/bootstrap.css'
import '../static/assets/css/flaticon.css'
import '../static/assets/css/font-awesome.css'
import '../static/assets/css/responsive.css'
import '../static/assets/css/style.css'
import '../static/assets/css/default-theme.css'
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(veeValidate)
Vue.use(BlockUI)
Vue.use(VueSweetalert2);
let toastedoptions = {
    duration: 3000,
    singleton: true
  }
Vue.use(Toasted, toastedoptions)
Vue.config.productionTip = false
if (process.env.NODE_ENV === 'development') {
    // set baseUrl from app
    axios.defaults.baseURL = 'http://localhost:8080/server/'
    window.serverPath = axios.defaults.baseURL
} else {
    // for prod
    // axios.defaults.baseURL = '/contactus/server/'
    axios.defaults.baseURL = '/donate/server/'
    window.serverPath = window.location.origin
}
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js